module.exports = __webpack_public_path__ + "ab67b3258a2b2b982f037e81defdad4b.jpg";